'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
/** @param {{
 *  el: HTMLElement
 *  context: {
 *    className: string
 *    getElement: (selector: string) => HTMLElement
 *    getElements: (selector: string) => HTMLElement[]
 *  }
 * }} options
 */
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var elements = {
    container: el,
    content: context.getElement('[data-el="toggle-content.content"]'),
    toggle: context.getElement('[data-el="toggle-content.toggle"]')
  };

  function getIsOpen() {
    return elements.container.getAttribute('aria-expanded') === 'true';
  }

  /** @param {MouseEvent} event */
  function handleToggleClick(event) {
    event.preventDefault();

    toggle();
  }

  function toggle() {
    var isOpen = getIsOpen();

    elements.container.setAttribute('aria-expanded', !isOpen);

    var toggleTextKey = isOpen ? 'toggleContentTranslationReadMore' : 'toggleContentTranslationReadLess';
    elements.toggle.textContent = elements.container.dataset[toggleTextKey];

    var contentTextKey = isOpen ? 'toggleContentCollapsedContent' : 'toggleContentExpandedContent';
    elements.content.innerHTML = elements.container.dataset[contentTextKey];
  }

  elements.toggle.addEventListener('click', handleToggleClick);
}